import React from 'react';
import { Heading } from '../../../components';

import css from '../ListingPage.module.css';
import { sanitiseText } from '../listingFieldUtils';
import classNames from 'classnames';

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false, fieldName } = props;
  const textClass = showAsIngress ? css.ingress : css.text;

  const content = sanitiseText(fieldName, text);

  return text ? (
    <section className={css.sectionText}>
      {heading ? (
        <Heading as="h2" rootClassName={classNames(css.sectionHeading, css.sectionHeadingInfo)}>
          {heading}
        </Heading>
      ) : null}
      <p className={textClass}>{content}</p>
    </section>
  ) : null;
};

export default SectionTextMaybe;
